import { http } from '@/api/http';
import type { OperationResult, Schemas } from '@/api/shared';

export const allergyProfileApi = {
  /** GET /persons/{guid}/allergy-profile — fetch singleton profile. */
  getAllergyProfile: (
    guid: string,
    options?: { signal?: AbortSignal },
  ): Promise<OperationResult<'getAllergyProfile'>> =>
    http.get<OperationResult<'getAllergyProfile'>>(
      `/persons/${encodeURIComponent(guid)}/allergy-profile`,
      options,
    ),

  /** PUT /persons/{guid}/allergy-profile/nkda — toggle NKDA flag. */
  setAllergyProfileNkda: (
    guid: string,
    body: Schemas['NkdaUpdate'],
    options?: { signal?: AbortSignal },
  ): Promise<Schemas['AllergyProfile']> =>
    http.put<Schemas['AllergyProfile']>(
      `/persons/${encodeURIComponent(guid)}/allergy-profile/nkda`,
      body,
      options,
    ),

  /** POST /persons/{guid}/allergy-profile/allergies — add an allergy. */
  addAllergy: (
    guid: string,
    body: Schemas['Allergy'],
    options?: { signal?: AbortSignal },
  ): Promise<Schemas['Allergy']> =>
    http.post<Schemas['Allergy']>(
      `/persons/${encodeURIComponent(guid)}/allergy-profile/allergies`,
      body,
      options,
    ),

  /** PUT /persons/{guid}/allergy-profile/allergies/{allergyGuid} — update an allergy. */
  updateAllergy: (
    guid: string,
    allergyGuid: string,
    body: Schemas['Allergy'],
    options?: { signal?: AbortSignal },
  ): Promise<Schemas['Allergy']> =>
    http.put<Schemas['Allergy']>(
      `/persons/${encodeURIComponent(guid)}/allergy-profile/allergies/${encodeURIComponent(allergyGuid)}`,
      body,
      options,
    ),

  /** DELETE /persons/{guid}/allergy-profile/allergies/{allergyGuid} — remove an allergy. */
  removeAllergy: (
    guid: string,
    allergyGuid: string,
    options?: { signal?: AbortSignal },
  ): Promise<undefined> =>
    http.delete<undefined>(
      `/persons/${encodeURIComponent(guid)}/allergy-profile/allergies/${encodeURIComponent(allergyGuid)}`,
      options,
    ),
};
